import { Navigate, Outlet } from "react-router-dom";

export default function PrivateRoute({ children }) {
    const isAuth = Boolean(localStorage.getItem("token"));
    if (!isAuth) return <Navigate to="/" replace />;
    return children ?? <Outlet />;
}
